module.exports = __webpack_public_path__ + "static/media/cover-image.90b3af0c.jpg";